/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Radio = require('backbone.radio');
var Ladda = require('ladda');

var BreadcrumbView = require('common/views/BreadcrumbView');

var eventOrganizationDetailsForm = require('../views/COCEventOrganizationDetailsView');
var SubmitEditEventOrganizationDetails = require('../services/SubmitEditEventOrganizationDetails');

var tmplCOCEditEventOrganizationDetails = require('../templates/COCEditEventOrganizationDetailsView.hbs');
require('../styles/COCEditEventOrganizationDetailsView.css');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCEditEventOrganizationDetails,

  className: 'coc-edit-event-organization-details container-fluid',

  ui: {
    breadcrumb: '.breadcrumb-container',
    eventOrganizationDetailsContainer: '.event-organization-details-container',
    submit: '.btn-submit'
  },

  regions: {
    breadcrumb: '@ui.breadcrumb',
    eventOrganizationDetailsContainer: '@ui.eventOrganizationDetailsContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var event = this.model.get('event');
    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#coc/dashboard',
            text: 'Home'
          },
          {
            link: '#coc/event/' + event.eventId,
            text: event.eventTitle
          },
          {
            text: 'Edit Organization Details'
          }
        ]
      })
    );
    var eventOrganizationDetailsModel = this.model;
    this.showChildView(
      'eventOrganizationDetailsContainer',
      new eventOrganizationDetailsForm({ model: eventOrganizationDetailsModel })
    );
    Syphon.deserialize(this, event);
  },

  validate: function() {
    return this.ui.eventOrganizationDetailsContainer.parsley().whenValidate();
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var l = Ladda.create(this.ui.submit[0]);
    l.start();
    var event = this.model.get('event');
    var formData = Syphon.serialize(this);
    formData.eventId = event.eventId;
    formData.organizationId = this.model.get('organizationId');
    formData.contactId = this.model.get('contactId');
    this.validate().done(function() {
      SubmitEditEventOrganizationDetails(formData)
        .done(function() {
          Radio.channel('navigate').trigger('show:int:coc:event', event.eventId);
        })
        .fail(function() {
          l.stop();
        });
    });
  }
});
